// extracted by mini-css-extract-plugin
export var body = "holding-module--body--5417e";
export var card = "holding-module--card--dcf64";
export var cta = "holding-module--cta--21f00";
export var glow = "holding-module--glow--6d42f";
export var heading = "holding-module--heading--da824";
export var logo = "holding-module--logo--5f70d";
export var page = "holding-module--page--5deb2";